// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3k7ip","footer":"ReportModalFilter_footer__3xiF0"};